import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core'; 
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MenuService } from 'src/app/services/menu/menu.service';
import { ParentMenuSelectComponent } from "../parent-menu-select/parent-menu-select.component";

@Component({
  selector: 'app-menu-modal',
  imports: [FormsModule, CommonModule, ReactiveFormsModule, ParentMenuSelectComponent],
  templateUrl: './menu-modal.component.html',
  styleUrl: './menu-modal.component.css'
})
export class MenuModalComponent {
  @Input() menuItem: any;
  @Input() isNew: boolean = false;
  menuItemTitle: string = '';
  menuItemVisibility: number = 1;
  load = false
  apiErrors: any = {};
  form!: FormGroup;


  @Input() allMenu: any[] = [];


constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private MenuService: MenuService,
    private ToastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      title: [this.menuItem?.title ?? '', [Validators.required, Validators.minLength(2)]],
      status: [this.menuItem?.status ?? 'active', Validators.required],
      parent: [this.menuItem?.parent ?? ''],
      disableSub: [this.menuItem?.disableSub ?? false],
      pageType: [this.menuItem?.pageType ?? 'static', Validators.required],
      position: [this.menuItem?.position ?? 'main', Validators.required],
      slug: [this.menuItem?.slug ?? '', Validators.required],
      url: [this.menuItem?.url ?? ''],
      target: [this.menuItem?.target ?? '_self'],
      visible: [this.menuItem?.visible ?? true],
      mainMenu: [this.menuItem?.mainMenu ?? false],
      background: [null],
      icon: [null],
    });
  }

  onBackgroundSelect(event: any) {
    const file = event.target.files[0];
    this.form.get('background')?.setValue(file);
  }

  onIconSelect(event: any) {
    const file = event.target.files[0];
    this.form.get('icon')?.setValue(file);
  }

onSelectParent(parentId: number) {
  this.menuItem.parent_id = parentId;
}
 

  saveChanges() {
    this.apiErrors = {};

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.load = true;

    const formData = new FormData();
    Object.entries(this.form.value).forEach(([key, value]) => {

      // file fields
      if (value instanceof File) {
        formData.append(key, value);
      }

      // null / undefined – skip
      else if (value === null || value === undefined) {
        return;
      }

      // booleans → string
      else if (typeof value === 'boolean') {
        formData.append(key, value ? '1' : '0');
      }

      // number → string
      else if (typeof value === 'number') {
        formData.append(key, value.toString());
      }

      // everything else → string
      else {
        formData.append(key, String(value));
      }
    });

    this.MenuService.updateMenuItem(formData).subscribe({
      next: (res: any) => {
        this.load = false;
        this.activeModal.close(res.data);
        this.ToastrService.success('შენახულია');
      },
      error: (err: any) => {
        this.load = false;

        if (err?.error?.errors) {
          this.apiErrors = err.error.errors;
          this.form.markAllAsTouched();
        }

        this.ToastrService.error('შეცდომა');
      }
    });
  }



}
